import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import LogoBar from '../components/LogoBar';
import ProblemSection from '../components/ProblemSection';
import Bridge from '../components/Bridge';
import HowItWorks from '../components/HowItWorks';
import SolutionsTabs from '../components/SolutionsTabs';
import ReportsSection from '../components/ReportsSection';
import ValueStack from '../components/ValueStack';
import IntegrationsGrid from '../components/IntegrationsGrid';
import PricingSection from '../components/PricingSection';
import Guarantee from '../components/Guarantee';
import FAQ from '../components/FAQ';
import ContactCTA from '../components/ContactCTA';
import Footer from '../components/Footer';
import useSmoothScroll from '../hooks/useSmoothScroll';

export default function LandingPage() {
  useSmoothScroll();

  useEffect(() => {
    trackPageView('/', 'SyncroX — Automatická synchronizace dokladů do Money S3');
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <LogoBar />
      <ProblemSection />
      <Bridge />
      <HowItWorks />
      <SolutionsTabs />
      <ReportsSection />
      <ValueStack />
      <IntegrationsGrid />
      <PricingSection />
      <Guarantee />
      <FAQ />
      <ContactCTA />
      <Footer />
    </>
  );
}
